<template>
  <v-app>
    <v-snackbar v-model="snackbar">
      {{ text }}

      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
    <v-container fluid class="pa-0 chat-background">
      <v-row justify="center" no-gutters>
        <v-col cols="12" sm="8" md="6">
          <v-card flat class="chat-card">
            <v-form ref="form">
              <v-card-actions>
                <v-select density="compact" v-model="username" :items="['riyad', 'ramu_vs']" :rules="[(v) => !!v || 'Required']"></v-select>
                <v-btn class="mt-n5" variant="flat" color="green" :loading="loading" @click="validateFormMethod()">Connect</v-btn>
              </v-card-actions>
            </v-form>
            <div class="pl-3 mt-n6">{{ connected ? "You are connected!!" : "You are not connected!!" }}</div>
            <v-divider></v-divider>
            <v-card :height="useDisplayObject.height - 150">
              <v-card-text class="chat-window">
                <v-list dense>
                  <v-list-item v-for="(message, index) in messages" :key="index" :class="username==message.username ? 'message-sent' : 'message-received'">
                    <v-card width="200px">
                    <v-card-text class="py-0">
                      <div class="bubble">
                        <span class="message-text">{{ message.text }}</span>
                        <div class="message-meta">
                          <small>{{ message.time }}</small>
                          <v-icon v-if="message.sent" small color="grey darken-1" class="ml-1"> mdi-check-all </v-icon>
                        </div>
                      </div>
                    </v-card-text>
                    </v-card>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
            <v-divider></v-divider>
            <v-card-actions class="chat-input">
              <v-text-field v-model="newMessage" label="Type a message..." outlined dense class="flex-grow-1" hide-details @keyup.enter="sendMessage" />
              <v-btn color="primary" @click="sendMessage"> Send </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import mqtt from "mqtt";
import { useDisplay } from "vuetify/lib/framework.mjs";
export default {
  name: "WhatsAppChatUI",
  data() {
    return {
      text: "",
      username: "",
      newMessage: "",

      loading: false,
      snackbar: false,
      connected: false,

      messages: [],

      client: null,
      useDisplayObject: {},
    };
  },
  mounted() {
    this.connected = false;
    this.useDisplayObject = useDisplay();
  },
  methods: {
    async validateFormMethod() {
      let names = ["ramu_vs", "riyad"];
      let result = await this.$refs.form.validate();
      if (result.valid) {
        if (names.includes(this.username)) {
          this.connectToMQTTMethod();
        } else {
          this.snackbar = true;
          this.text = "Incorrect user name!!";
        }
      } else {
        this.snackbar = true;
        this.text = "Please enter user name!!";
      }
    },
    connectToMQTTMethod() {
      var self = this;
      self.loading = true;
      self.connected = false;
      let conn3 = "wss://broker.stichh.com:9002/mqtt";
      self.client = mqtt.connect(conn3, {
        clientId: self.username,
        clean: true,
        connectTimeout: 10000,
        username: self.username,
        password: self.username,
      });

      console.log("Attempting to connect...");

      self.client.on("connect", function () {
        self.connected = true;
        self.loading = false;
        console.log("✅ Connected to MQTT Broker (WSS)");

        self.client.subscribe("default/topic", function (err) {
          if (!err) {
            console.log("✅ Subscribed to topic: default/topic");
          } else {
            console.log("❌ Subscription Error:", err);
          }
        });
      });

      self.client.on("error", function (err) {
        self.connected = false;
        self.loading = false;
        console.error("❌ Connection error:", err);
      });

      self.client.on("close", function () {
        self.connected = false;
        self.loading = false;
        console.log("🔌 Disconnected from MQTT Broker");
      });

      self.client.on("message", (topic, message) => {
        console.log(`📩 Received message on topic '${topic}':`, message.toString());
        let messageObject = message.toString();
        self.messages.push({...JSON.parse(messageObject)});
      });
    },
    sendMessage() {
      if (this.connected) {
        this.client.publish(
          "default/topic",
          JSON.stringify({
            ...{
              username:this.username,
              text: this.newMessage,
              sent: true,
              time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
            },
          })
        );
      } else {
        this.snackbar = true;
        this.text = "You are not connected!!";
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const chatWindow = this.$el.querySelector(".chat-window");
        chatWindow.scrollTop = chatWindow.scrollHeight;
      });
    },
  },
};
</script>

<style scoped>
/* Chat background mimicking WhatsApp's subtle pattern or color */
.chat-background {
  background-color: #e5ddd5;
  min-height: 100vh;
  padding-top: 16px;
}

/* Chat card styles */
.chat-card {
  border-radius: 8px;
  overflow: hidden;
  margin: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Header style */
.chat-header {
  background-color: #ededed;
  font-weight: bold;
  justify-content: center;
}

/* Chat window */
.chat-window {
  overflow-y: auto;
  background-color: #fff;
  padding: 16px;
}

/* Input area */
.chat-input {
  background-color: #f0f0f0;
  padding: 8px;
}

/* Message alignment */
.message-sent {
  display: flex;
  justify-content: flex-end;
  margin: 8px 0;
}
.message-received {
  display: flex;
  justify-content: flex-start;
  margin: 8px 0;
}

/* Bubble style for messages */
.bubble {
  width: 70%;
  position: relative;
  padding: 10px 14px;
  border-radius: 18px;
  word-wrap: break-word;
  background-color: #dcf8c6; /* Default green for sent messages */
}
.message-received .bubble {
  background-color: #fff;
  border: 1px solid #ddd;
}

/* Bubble tail for sent messages */
.message-sent .bubble::after {
  content: "";
  position: absolute;
  right: -8px;
  bottom: 0;
  border-top: 8px solid #dcf8c6;
  border-right: 8px solid transparent;
}

/* Bubble tail for received messages */
.message-received .bubble::before {
  content: "";
  position: absolute;
  left: -8px;
  bottom: 0;
  border-top: 8px solid #fff;
  border-left: 8px solid transparent;
}

/* Message text and metadata */
.message-text {
  display: block;
}
.message-meta {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 0.75rem;
  margin-top: 4px;
  color: #999;
}
</style>

<!-- <template>
  <div>
    <h1>MQTT WebSocket Connection</h1>
    <h1>{{ message }}</h1>
  </div>
</template>

<script>
import mqtt from "mqtt";

export default {
  data: () => ({
    message: "",
  }),
  mounted() {
    this.connectToMQTT();
  },
  methods: {
    connectToMQTT() {
      let conn3 = "wss://broker.stichh.com:9002/mqtt";
      const client = mqtt.connect(conn3, {
        clientId: "ramu_vs",
        clean: true,
        connectTimeout: 10000,
        username: "ramu_vs",
        password: "ramu_vs",
      });

      console.log("Attempting to connect...");

      client.on("connect", function () {
        console.log("✅ Connected to MQTT Broker (WSS)");

        client.subscribe("default/topic", function (err) {
          if (!err) {
            console.log("✅ Subscribed to topic: default/topic");
          } else {
            console.log("❌ Subscription Error:", err);
          }
        });
      });

      client.on("message", (topic, message) => {
        console.log(`📩 Received message on topic '${topic}':`, message.toString());
      });

      client.on("error", function (err) {
        console.error("❌ Connection error:", err);
      });

      client.on("close", function () {
        console.log("🔌 Disconnected from MQTT Broker");
      });

      // const options = {
      //   username: "ramu.pal",
      //   password: "123456",
      //   protocolVersion: 4,
      //   clean: true,
      //   reconnectPeriod: 5000,
      // };
      // const brokerUrl = "wss://b-7fe64619-907e-472b-b543-6ec90860ac75-1.mq.us-east-1.amazonaws.com:61619";
      // const client = mqtt.connect(brokerUrl, options);
      // client.on("connect", () => {
      //   console.log("✅ Connected to Amazon MQ via WebSockets");
      //   client.subscribe("test/topic", (err) => {
      //     if (!err) {
      //       console.log("📩 Subscribed to test/topic");
      //     } else {
      //       console.error("❌ Subscription error:", err);
      //     }
      //   });
      // });

      // client.on("message", (topic, message) => {
      //   // console.log(`📨 Received on ${topic}: ${message.toString()}`);

      //   this.message = `📨 Received on ${topic}: ${message.toString()}`;
      // });

      // client.on("error", (err) => {
      //   console.error("❌ MQTT Error:", err.message);
      // });

      // client.on("close", () => {
      //   console.log("🔌 Disconnected from Amazon MQ");
      // });
    },
  },
};
</script> -->
